import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0259213c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "height"]
const _hoisted_2 = {
  key: 0,
  class: "previewBox"
}


import { ref, defineComponent, defineProps } from 'vue'
import { useSite2Station, isJA, isKO, isEN } from '@/store'
const station = useSite2Station()
const __default__ = defineComponent({
  name: 'DynamicIframe'
})

function setup(__props) {

const props = __props
window.addEventListener('message', function (e) {
  if (e.data.type === 'height') {
    console.log('height', e.data.data)
    iframeData.value.height = e.data.data
  } else if (e.data.type === 'imgUrl') {
    console.log('imgUrl', e.data.data)
    iframeData.value.imgUrl = e.data.data
    iframeData.value.showShadow = e.data.showShadow || false
  }
  // if (e.origin === 'https://iframe.theckb.com') {
  //   // console.log(e.origin) // 父页面所在的域
  //   console.log(e.data) // 父页面发送的消息, hello, child!

  //   if (e.data.type === 'height') {
  //     iframeData.value.height = e.data.data
  //   } else if (e.data.type === 'imgUrl') {
  //     iframeData.value.imgUrl = e.data.data
  //   }
  // }
})


const heightList: any = ref({
  plugin: '5944px'
})
// https://www.theckbkorea.com/%EA%B5%AC%EB%A7%A4-%EC%A3%BC%EC%9D%98%EC%82%AC%ED%95%AD 插件跳转

let iframeSrc = `https://iframe.theckb.com/${props.campaign}.html?host=${window.location.host}&v=${new Date().getTime()}`
if (isKO()) {
  if (props.campaign === 'qualityrules') {
    iframeSrc = 'https://iframe.theckb.com/InspectionAdditionalItems/index.html'
  }
  if (props.campaign === 'plugin') {
    iframeSrc = 'https://www.theckbkorea.com/%EA%B5%AC%EB%A7%A4-%EC%A3%BC%EC%9D%98%EC%82%AC%ED%95%AD'
  }
} else if (isEN()) {
  if (props.campaign === 'qualityrules') {
    iframeSrc = 'https://iframe.theckb.com/InspectionAdditionalItems_en/index.html'
  }
  if (props.campaign === 'plugin') {
    iframeSrc = 'https://www.theckbofficial.com/'
  }
}
// 只有日本站才有售后补偿标准
if (isJA()) {
  if (props.campaign === 'aftersalerules') {
    iframeSrc = 'https://iframe.theckb.com/afterSaleComStandard.html'
  }
}
const iframeData: any = ref({
  height: '1080px',
  iframeSrc: iframeSrc,
  imgUrl: '',
  showShadow: false
})

return (_ctx: any,_cache: any) => {
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("iframe", {
      src: iframeData.value.iframeSrc,
      height: `${iframeData.value.height}`,
      class: "iframe"
    }, null, 8, _hoisted_1),
    (iframeData.value.imgUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_image_viewer, {
            hideOnClickModal: "",
            "url-list": [iframeData.value.imgUrl],
            onClose: _cache[0] || (_cache[0] = ($event: any) => (iframeData.value.imgUrl = ''))
          }, null, 8, ["url-list"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  campaign: {
    type: String,
    default: () => {
      return 'index'
    }
  }
},
  setup})